import InsurerLogo from "./InsurerLogo";
import NormalText from "./NormalText";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteResponseFromDb,
  getCheckedForCompareForResponseId,
  getExcelApiStatus,
  getInhouseQuotes,
  getExternalQuotes,
  getInsuerName,
  getInsurerCode,
  getInsurerSource,
  getisViewQuoteModalOpen,
  getRecalculate,
  getInsurerBindType,
  getInsurerQuotesBy,
  getInsurerConfigType,
  addToTotalApiCallsToGetResponse,
  subtractToTotalApiCallsToGetResponse,
  getTotalApiCallsToGetResponseInProgress,
  getTotalApiCallsToGetResponseInProgressPreviousValue,
  quoteyScoreLoadingDecider,
  quoteyScoreRecalculateDecider,
  udpateQuoteyScoreInStore,
  getResponseBindType,
  getResponseDetail,
} from "../store/quotes";
import CompareSwitchComp from "./CompareSwitchComp";
import RscoreDeciderComp from "./RscoreDecider";
import { PriceDeciderComp } from "./PriceDecider";
import { CoverageDeciderComp } from "./CoverageDecider";
import { StarRatingForInsurerHub } from "./StarRating";
import SettingsIcon from "@material-ui/icons/Settings";
import ReactTooltip from "react-tooltip";
import * as theme from "../theme";
import DeleteIcon from "@material-ui/icons/Delete";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import {
  PossibleApiStatusValues,
  PossibleExcelApiStatusValues,
} from "../store/helperfuncs";
import { ConfigIcon } from "./ConfigIcon";
import { configIconDesc } from "../helper/constants";
import { setConfigType } from "../helper/helper";
import { toast } from "react-toastify";
import { getBrokerInformation } from "../store/broker";
import translations from "../utils/translations";

const ResponseRow = (props) => {
  const { ColoumnWidth, responseid, prospectid } = props;
  const [toolTip, setToolTip] = useState(false);
  const insurername = useSelector(getInsuerName({ responseid }));
  const insurercode = useSelector(getInsurerCode({ responseid }));
  const quotesource = useSelector(getInsurerSource({ responseid }));
  const excelApiStatus = useSelector(getExcelApiStatus(responseid));
  const isViewQuoteModalOpen = useSelector(
    getisViewQuoteModalOpen({ responseid })
  );
  const insurerQuotesBy = useSelector(getInsurerQuotesBy({ responseid }));
  const insurerBindType = useSelector(getInsurerBindType({ responseid }));
  const responseBindType = useSelector(getResponseBindType({ responseid }));
  let [insurerConfigType, setinsurerConfigType] = useState(
    setConfigType(insurerQuotesBy, insurerBindType)
  );
  const brokerInfo = useSelector(getBrokerInformation);
  const languagepreference =
    brokerInfo?.information?.languagepreference || "en";
  useEffect(() => {
    if (responseBindType) {
      setinsurerConfigType(setConfigType(insurerQuotesBy, responseBindType));
    }
  }, [responseBindType]);
  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };

  const borderWidth = "5px";
  const responseDetail = useSelector(getResponseDetail(responseid));
  const checkedforcompare = useSelector(
    getCheckedForCompareForResponseId({ responseid })
  );
  const recalculate = useSelector(getRecalculate);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      excelApiStatus === PossibleExcelApiStatusValues.notstarted &&
      recalculate
    ) {
      if (quotesource === "inhouse")
        dispatch(getInhouseQuotes({ responseid, languagepreference }));
      else if (quotesource === "external") {
        dispatch(getExternalQuotes({ responseid }));
      }
    }
  });

  useEffect(() => {
    if (excelApiStatus === PossibleExcelApiStatusValues.loading) {
      dispatch(addToTotalApiCallsToGetResponse());
    }
    if (
      excelApiStatus === PossibleExcelApiStatusValues.failed ||
      excelApiStatus === PossibleApiStatusValues.success
    ) {
      dispatch(subtractToTotalApiCallsToGetResponse());
    }
  }, [excelApiStatus]);

  useEffect(() => {
    if (responseDetail.errorMsg) {
      toast.error(responseDetail.errorMsg);
    }
  }, [responseDetail]);

  const showLoading = useSelector(quoteyScoreLoadingDecider);

  return (
    <div
      style={{
        borderRadius: 20,
        border: `${borderWidth} solid white`,
        height: "10vh",
        maxHeight: 96,
        marginBottom: 7,
        display: "flex",
        backgroundColor: checkedforcompare
          ? theme.COLORS.tertiary_ligthindigo
          : "inherit",
        width: "100%",
      }}
    >
      <div
        style={{
          width: `calc(${ColoumnWidth.toggle} - ${borderWidth} + 1px)`,
          ...commonStyle,
          ...borderCommon,
          paddingLeft: 20,
        }}
      >
        <CompareSwitchComp responseid={responseid}></CompareSwitchComp>
      </div>
      <div
        style={{
          width: `calc(${ColoumnWidth.insurer} + 1px)`,
          padding: 12,
          ...commonStyle,
          ...borderCommon,
        }}
      >
        <InsurerLogo code={insurercode}></InsurerLogo>
      </div>

      <div
        style={{
          width: `calc(${ColoumnWidth.product} + 2px)`,
          ...commonStyle,
          ...borderCommon,
          textAlign: "center",
          paddingLeft: "1%",
          paddingRight: "1%",
          lineHeight: 1.5,
        }}
      >
        <NormalText text={insurername} fontWeight={"normal"}></NormalText>
      </div>

      <div
        style={{
          width: `calc(${ColoumnWidth.recommendedscore} + 3px)`,
          ...commonStyle,
          ...borderCommon,
          textAlign: "center",
          paddingLeft: "2.5%",
          paddingRight: "2.5%",
        }}
      >
        <RscoreDeciderComp
          responseid={responseid}
          showLoading={showLoading}
        ></RscoreDeciderComp>
      </div>
      <div
        style={{
          width: `calc(${ColoumnWidth.price} + 1px)`,
          ...commonStyle,
          ...borderCommon,
          textAlign: "center",
        }}
      >
        <PriceDeciderComp responseid={responseid}></PriceDeciderComp>
      </div>
      <div
        style={{
          width: `calc(${ColoumnWidth.type} + 1px)`,
          ...commonStyle,
          ...borderCommon,
          textAlign: "center",
        }}
      >
        <div data-tip data-for={`config icon ${responseid}`}>
          <ConfigIcon configType={insurerConfigType} />
        </div>
        <ReactTooltip
          id={`config icon ${responseid}`}
          effect="solid"
          clickable={true}
          place="top"
        >
          <div style={{ maxWidth: "20vmin", fontSize: "0.7rem" }}>
            {configIconDesc[insurerConfigType - 1][languagepreference]}
          </div>
        </ReactTooltip>
      </div>
      <div
        style={{
          width: `calc(${ColoumnWidth.coveragelevel} + 2px)`,
          ...commonStyle,
          ...borderCommon,
          textAlign: "center",
        }}
      >
        <CoverageDeciderComp
          insurercode={insurercode}
          responseid={responseid}
          quotesource={quotesource}
          isViewQuoteModalOpen={isViewQuoteModalOpen}
        ></CoverageDeciderComp>
      </div>

      <div
        style={{
          width: `calc(${ColoumnWidth.rateit} - ${borderWidth} + 2px)`,
          ...commonStyle,
          ...borderCommon,
          textAlign: "center",
          borderRight: 0,
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "8px",
          }}
        >
          <StarRatingForInsurerHub
            readonly={false}
            responseid={responseid}
            checkedforcompare={checkedforcompare}
          ></StarRatingForInsurerHub>
        </div>
        <div
          style={{
            position: "absolute",
            alignSelf: "flex-end",
            justifyContent: "flex-end",
            paddingRight: "7px",
            paddingBottom: "5px",
            width: "100%",
            display: "flex",
          }}
        >
          <ReactTooltip
            id={responseid}
            effect="solid"
            getContent={() => (
              <Menu
                key={responseid}
                responseid={responseid}
                insurercode={insurercode}
                prospectid={prospectid}
              ></Menu>
            )}
            delayHide={100}
            delayShow={100}
            delayUpdate={500}
            place={"top"}
            type={"light"}
            clickable={true}
          ></ReactTooltip>
          <div data-for={responseid} data-tip="1">
            <SettingsIcon
              style={{
                fontSize: "1.6vmin",
                color: "lightgrey",
                cursor: "pointer",
              }}
            ></SettingsIcon>
          </div>
        </div>
      </div>
    </div>
  );
};

const Menu = (props) => {
  const { responseid, insurercode, prospectid } = props;
  const dispatch = useDispatch();
  const history = useNavigate();
  const brokerInfo = useSelector(getBrokerInformation);
  const languagepreference =
    brokerInfo?.information?.languagepreference || "en";
  return (
    <div
      style={{
        width: "15vmin",
        height: "15vmin",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <ButtonForToolTip
        color={theme.COLORS.primary_navyblue}
        text={translations[languagepreference].add}
        onClick={() => {
          //history(`/editresponse?id=${responseid}&pid=${prospectid}`)
          document.location.href = `/editresponse?id=${responseid}&pid=${prospectid}`;
        }}
      ></ButtonForToolTip>
      <ButtonForToolTip
        color={theme.COLORS.primary_navyblue}
        text={"Edit"}
        onClick={() => {
          //history(`/editresponse?id=${responseid}&pid=${prospectid}`)
          document.location.href = `/editresponse?id=${responseid}&pid=${prospectid}`;
        }}
      ></ButtonForToolTip>
      <ButtonForToolTip
        color={theme.COLORS.primary_navyblue}
        icon={<DeleteIcon></DeleteIcon>}
        text={<div>Delete</div>}
        onClick={() => {
          dispatch(deleteResponseFromDb({ responseid, insurercode }));

          // TODO : in future toast to show undo
          // TODO: dispatch to delete this
        }}
      ></ButtonForToolTip>
    </div>
  );
};

const ButtonForToolTip = (props) => {
  const { onMouseOver, onClick, onMouseOut, color, text, icon } = props;

  return (
    <div
      style={{
        width: "100%",
        height: "25%",
        backgroundColor: color,
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 10,
        fontFamily: "GibsonRegular",
        color: "white",
        fontSize: 12,
        letterSpacing: 2,
      }}
      onMouseOver={onMouseOver}
      onClick={onClick}
      onMouseOut={onMouseOut}
    >
      {text}
      {icon}
    </div>
  );
};

export default ResponseRow;
